import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { QUERY_KEY_CHAT_THREAD, QUERY_KEY_CHAT_MESSAGES } from './useChatThreads';

interface SendTestMessageInput {
  threadId: string;
  content: string;
}

export function useSendTestMessage() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, SendTestMessageInput>({
    mutationFn: async ({ threadId, content }) => {
      await api.post(`/chat/threads/${threadId}/messages`, {
        content,
        type: 'TEXT',
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_CHAT_THREAD, variables.threadId] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_CHAT_MESSAGES, variables.threadId] });
    },
  });
}
